import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select'
import { checkboxData } from './checkboxData';
import './style.css'
import { useUserAuth } from '../../context/UserAuthContext';
import { useFormik } from 'formik';
import { anchorTtkSchema } from '../schemas';
import axios from "axios";
import { NumericFormat } from "react-number-format";
import ThinksToKnowStatus from './ThinksToKnowStatus';

const AnchorTTK = () => {
    const { language, token,currency} = useUserAuth()
    const workingSinceOption = checkboxData.workSinceOption;
    const languageOption = checkboxData.languageOption;
    const eventTypeAnchorOption = checkboxData.eventTypeAnchor;
    const areaOfWorkingOption = checkboxData.areaOfWorking;
    const { user } = useUserAuth();
    const merchant_id = user.uid;
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const [merchant, setMerchant] = useState({});

    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(
                `${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            const data = res.data.data;
            const details = data[0].details;
            if (details) {
                setMerchant(details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };

    useEffect(() => {
        if (!merchant_id) return
        getSingleDocumentHandler()
    }, [merchant_id, token])
    const formik = useFormik({
        initialValues: {
            startingPrice: Math.floor(merchant?.startingPrice * currency.value) || '',
            Duration: merchant?.Duration || '',
            language: merchant?.language || [],
            workingSince: merchant?.workingSince || [],
            areaOfWork: merchant?.areaOfWork || [],
            // travelPreference: merchant?.travelPreference || [],
            eventTypeAnchor: merchant?.eventTypeAnchor || [],
        },
        enableReinitialize: true,
        validationSchema: anchorTtkSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    id: merchant_id,
                    details: { ...values,
                         startingPrice: Math.floor(values.startingPrice * currency.country_value)
                     },
                };

                const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                    setMerchant(values);
                    formik.setValues(values);
                    setTtkEditMode(false);
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                    setTtkEditMode(false);
                } else {
                    toast.info(res.data.message || "Request submitted.");
                    setTtkEditMode(false);
                }

            } catch (error) {
                console.error(`Error ${error}`);
                toast.error('An error occurred while submitting the data.');
            }
        },
    });
    const [ttkEditMode, setTtkEditMode] = useState(false)
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                 <ThinksToKnowStatus/>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header  text-white text-center ' style={{ backgroundColor: '#085f9a' }}>
                                <h5> {language === 'en' ? 'Things to Know' : 'जानने योग्य जानकारी भरे'}</h5>
                            </div>
                            <div className='card-body'>
                                {
                                    merchant && (
                                        <>
                                            <div className='table-responsive'>
                                                <table className='table text-center' cellPadding={0} cellSpacing={0} style={{ border: '1px solid #fff ' }}>
                                                    <tbody className='ttk_preview'>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th style={{ width: '25%' }}>Working Since</th>
                                                            <th style={{ width: '25%' }}>Starting Price</th>
                                                            <th style={{ width: '25%' }}>Languages </th>
                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.workingSince?.map((item, index) => {
                                                                    return <p key={index}>{item.value}</p>
                                                                })
                                                            }</td>

                                                            <td>
                                                              <NumericFormat
                              value={Math.floor(
                                currency.value * merchant.startingPricet
                              )}
                              displayType="text"
                              thousandsGroupStyle={
                                currency.symbol === "₹" ? "lakh" : "thousand"
                              }
                              thousandSeparator=","
                              renderText={(formattedValue) => (
                                <span>
                                  {currency.symbol}&nbsp;{formattedValue}
                                </span>
                              )}
                            />
                                                            </td>
                                                            <td>{
                                                                merchant.language?.map((item, index) => {
                                                                    return (
                                                                        <span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span>{item.value} </span>
                                                                        </span>
                                                                    )
                                                                })
                                                            }</td>


                                                        </tr>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th>Types Of Event Cover</th>
                                                            <th>Duration</th>
                                                            <th>Areas Of Services</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.eventTypeAnchor
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <span key={index}>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span >{item.value} </span>
                                                                            </span>)
                                                                    })
                                                            }</td>

                                                            <td>{merchant.Duration}</td>
                                                            <td>{
                                                                merchant.areaOfWork
                                                                    ?.map((item, index) => {
                                                                        return (<span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span >{item.value} </span>
                                                                        </span>)
                                                                    })
                                                            }</td>
                                                        </tr>


                                                    </tbody>
                                                </table>

                                            </div>
                                        </>
                                    )
                                }
                                <center >
                                    <button className='btn text-white mb-2' style={{ backgroundColor: '#085f9a' }} onClick={() => setTtkEditMode(!ttkEditMode)}>{`${merchant ? 'Make Changes' : 'Tell me more about yourself'}`}</button>
                                </center>
                                {
                                    ttkEditMode && (
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Working Since <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={workingSinceOption}
                                                            selected
                                                            value={formik.values.workingSince}
                                                            onChange={(workingSince) => formik.setFieldValue('workingSince', workingSince)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.workingSince && formik.errors.workingSince ? (
                                                            <div className="text-danger">{formik.errors.workingSince}</div>
                                                        ) : null}
                                                    </div>

                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Areas Of Services</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={areaOfWorkingOption}
                                                            selected
                                                            value={formik.values.areaOfWork}
                                                            onChange={(areaOfWork) => formik.setFieldValue('areaOfWork', areaOfWork)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.areaOfWork && formik.errors.areaOfWork ? (
                                                            <div className="text-danger">{formik.errors.areaOfWork}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Starting Price <span className='text-danger'>*</span></label>
                                                        <input
                                                            type='number'
                                                            placeholder='Starting Price'
                                                            name="startingPrice"
                                                            className='form-control'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.startingPrice}
                                                        />
                                                        {formik.touched.startingPrice && formik.errors.startingPrice ? (
                                                            <div className="text-danger">{formik.errors.startingPrice}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Languages<span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={languageOption}
                                                            selected
                                                            value={formik.values.language}
                                                            onChange={(language) => formik.setFieldValue('language', language)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.language && formik.errors.language ? (
                                                            <div className="text-danger">{formik.errors.language}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Types Of Event Cover<span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={eventTypeAnchorOption}
                                                            selected
                                                            value={formik.values.eventTypeAnchor}
                                                            onChange={(eventTypeAnchor) => formik.setFieldValue('eventTypeAnchor', eventTypeAnchor)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.eventTypeAnchor && formik.errors.eventTypeAnchor ? (
                                                            <div className="text-danger">{formik.errors.eventTypeAnchor}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Duration<span className='text-danger'>*</span></label>
                                                        <select
                                                            name="Duration"
                                                            className="form-control"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.Duration}
                                                        >
                                                            <option>Select</option>
                                                            <option value="1 Hour">1 Hour</option>
                                                            <option value="2 Hours">2 Hours</option>
                                                            <option value="3 Hours">3 Hours</option>
                                                            <option value="According to the Event">According to the Event</option>
                                                        </select>
                                                        {formik.touched.Duration && formik.errors.Duration ? (
                                                            <div className="text-danger">{formik.errors.Duration}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='form-group text-center'>
                                                    <button className='btn btn-primary' type='submit'>{ttkEditMode ? 'Save Changes' : 'Submit'}</button>
                                                </div>
                                            </div>
                                        </form>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AnchorTTK